import styled from 'styled-components';

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-row: 4;
  grid-column: 1 / span 3;
  justify-content: center;
  align-self: end;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  align-self: center;
`;
